var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowlocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.571,
    height: 83.662,
    viewBox: "0 0 53.571 83.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M26.71,83.662h0c-.138,0-.354-.147-.645-.437C21.471,78.639,0,40.486,0,26.784A26.786,26.786,0,0,1,45.726,7.845a26.609,26.609,0,0,1,7.845,18.939c0,3.4-1.322,8.437-3.93,14.977a196.544,196.544,0,0,1-8.78,18.606c-6.662,12.6-13.2,22.773-14.075,23.276A.155.155,0,0,1,26.71,83.662Zm.076-72.384A15.507,15.507,0,1,0,42.293,26.784,15.525,15.525,0,0,0,26.787,11.278Z",
    fill: "#f5f5f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowlocation);
export default __webpack_public_path__ + "static/media/flowlocation.b3d400b89344009bb68c391c3b7d8bfc.svg";
export { ForwardRef as ReactComponent };